var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5333 12.666C13.5333 12.666 12.7579 25.006 19.7279 29.708H12.6666C12.6666 29.708 7.93526 24.938 13.5333 12.666ZM29.3333 25.3327H42.8133V29.0087H28.6666V25.3327H29.3333Z",
    fill: "#4A3163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.388 36.3757C13.229 36.3757 14.7214 34.8833 14.7214 33.0423C14.7214 31.2014 13.229 29.709 11.388 29.709C9.54707 29.709 8.05469 31.2014 8.05469 33.0423C8.05469 34.8833 9.54707 36.3757 11.388 36.3757Z",
    fill: "#D0CFCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4066 36.3757C38.2475 36.3757 39.7399 34.8833 39.7399 33.0423C39.7399 31.2014 38.2475 29.709 36.4066 29.709C34.5656 29.709 33.0732 31.2014 33.0732 33.0423C33.0732 34.8833 34.5656 36.3757 36.4066 36.3757Z",
    fill: "#D0CFCE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 24.6668H18.3925L18.9265 19.7168",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8131 29.7087H12.6664L11.6011 27.7333C10.9876 26.5956 10.6664 25.3233 10.6664 24.0307V23.5207C10.6356 22.5097 10.7707 21.5005 11.0664 20.5333L12.6664 14.6667C12.6664 13.686 13.6858 12 14.6664 12L41.0371 12.26C41.508 12.26 41.9596 12.447 42.2927 12.7799C42.6257 13.1129 42.8129 13.5644 42.8131 14.0353V29.7087Z",
    stroke: "black",
    strokeWidth: 1.39133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5315 32.3125H16.8115",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.388 36.3757C13.229 36.3757 14.7214 34.8833 14.7214 33.0423C14.7214 31.2014 13.229 29.709 11.388 29.709C9.54707 29.709 8.05469 31.2014 8.05469 33.0423C8.05469 34.8833 9.54707 36.3757 11.388 36.3757Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4066 36.3757C38.2475 36.3757 39.7399 34.8833 39.7399 33.0423C39.7399 31.2014 38.2475 29.709 36.4066 29.709C34.5656 29.709 33.0732 31.2014 33.0732 33.0423C33.0732 34.8833 34.5656 36.3757 36.4066 36.3757Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.667 12.666V29.3327M29.3337 23.3327H42.813M40.667 24.666L41.3337 21.3327M29.3337 25.3327H42.8137V29.0087H28.667V25.3327H29.3337Z",
    stroke: "black",
    strokeWidth: 1.39133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5335 12.666C13.5335 12.666 12.7582 25.006 19.7282 29.708M17.0948 24.666V26.5227",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0485 29.7098C40.0485 29.5241 40.1223 29.3461 40.2535 29.2148C40.3848 29.0835 40.5629 29.0098 40.7485 29.0098H43.5459C43.7315 29.0098 43.9096 29.0835 44.0408 29.2148C44.1721 29.3461 44.2458 29.5241 44.2458 29.7098C44.2458 29.8954 44.1721 30.0735 44.0408 30.2047C43.9096 30.336 43.7315 30.4098 43.5459 30.4098H40.7472C40.5616 30.4096 40.3838 30.3358 40.2526 30.2045C40.1215 30.0732 40.0485 29.8953 40.0485 29.7098Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 28.3538C10.3457 27.0865 8.76633 28.5998 8.66699 28.6658",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory_icon.833eb0d5e4d781df0333059d5237a759.svg";
export { ForwardRef as ReactComponent };